import { Accordion, Box, Collapse, Group, LoadingOverlay, Stack, Text, UnstyledButton } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconRoute } from '@tabler/icons-react';
import { usePayoutOrderCascadeEvents } from '~/entities/payout';
import { CascadeAttempt } from './components';

interface CascadeEventsProps {
    id: string;
}

export const CascadeEvents = ({ id }: CascadeEventsProps) => {
    const [opened, { toggle }] = useDisclosure(false);
    const cascadeEvents = usePayoutOrderCascadeEvents({ 'orderId.value': id });
    const attempts = cascadeEvents.data?.items ?? [];

    return (
        <Stack>
            <UnstyledButton onClick={toggle}>
                <Group>
                    <IconRoute />
                    Показать путь по каскаду
                </Group>
            </UnstyledButton>

            <Collapse expanded={opened}>
                <Box pos='relative'>
                    <LoadingOverlay visible={cascadeEvents.isLoading} />
                    <Accordion>
                        {attempts.length > 0 && !cascadeEvents.isLoading ? (
                            attempts.map((attempt, index) => (
                                <CascadeAttempt
                                    key={attempt.createdAt ?? index}
                                    attempt={attempt}
                                    index={index}
                                />
                            ))
                        ) : (
                            <Text ta='center'>История отсутствует</Text>
                        )}
                    </Accordion>
                </Box>
            </Collapse>
        </Stack>
    );
};
